module.exports = __webpack_public_path__ + "img/binamo-postback.en.5c4f5c11.jpg";